<template>
    <div class="main">
        <!-- Um overlay só para a tela inteira: o servidor, as abas e a grade
             chegam em requisições distintas, e mostrar as abas antes da grade
             fazia a mensagem de "nenhum evento configurado" piscar. -->
        <div v-loading="carregando">
            <c-panel>
                <!-- Identificação: servidor e instituição selecionados na listagem -->
                <el-form label-position="top" class="u-mb-10">
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="12" :md="12">
                            <el-form-item label="Servidor">
                                <el-input :value="servidor.nome" disabled></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="12">
                            <el-form-item label="Unidade">
                                <el-input :value="servidor.instituicao_nome" disabled></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="12" :sm="6" :md="6">
                            <el-form-item label="Nr. Registro">
                                <el-input :value="servidor.nr_registro" disabled></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="12" :sm="6" :md="6">
                            <el-form-item label="Cargo">
                                <el-input :value="servidor.cargo" disabled></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="12" :sm="6" :md="6">
                            <el-form-item label="Matrícula/Contrato">
                                <el-input :value="servidor.matricula_contrato" disabled></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="12" :sm="6" :md="6">
                            <el-button @click="voltar" plain icon="el-icon-back" style="width: 100%; margin-top: 21px;">VOLTAR</el-button>
                        </el-col>
                    </el-row>

                    <!-- Referências do sistema de RH. Férias e Licença contam os dias
                         dentro da competência escolhida na aba Folha, por isso o campo
                         Frequência aparece junto: é a competência a que se referem. -->
                    <el-row :gutter="10">
                        <el-col :xs="12" :sm="6" :md="4">
                            <el-form-item label="Frequência">
                                <el-input :value="competenciaLabel" disabled></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="6" :sm="4" :md="3">
                            <el-form-item label="Férias">
                                <el-input :value="String(gradeDiasFerias)" disabled></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="6" :sm="4" :md="3">
                            <el-form-item label="Licença">
                                <el-input :value="String(gradeDiasLicenca)" disabled></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="12" :sm="5" :md="5">
                            <el-form-item label="SAL BASE (001)">
                                <el-input :value="salarioBase" disabled></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="12" :sm="5" :md="9">
                            <el-form-item label="Referência">
                                <el-input :value="servidor.salario_descricao || '-'" disabled></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </c-panel>

            <el-tabs v-model="aba" type="border-card">

                <!-- ============================ LICENÇA ============================ -->
                <el-tab-pane label="LICENÇA" name="licenca">
                    <el-alert v-if="gradeBloqueada" type="error" :closable="false" class="u-mb-15"
                        :title="gradeMotivo"></el-alert>
                    <div class="u-text-right u-mb-10">
                        <el-button type="primary" size="small" icon="el-icon-plus" @click="abrirModalLicenca()">ADICIONAR</el-button>
                    </div>

                    <div class="container-table">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th style="width: 110px;">Início</th>
                                    <th style="width: 110px;">Término</th>
                                    <th style="width: 90px;" class="u-text-center">Nr. Dias</th>
                                    <th>Tipo Licença</th>
                                    <th class="hidden-mobile">Observação</th>
                                    <th style="width: 110px;" class="u-text-center">Ação</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in licencas" :key="item.id">
                                    <td>{{ formataData(item.data_inicio) }}</td>
                                    <td>{{ formataData(item.data_final) }}</td>
                                    <td class="u-text-center">{{ item.nr_dias }}</td>
                                    <td>{{ item.tipo_descricao }}</td>
                                    <td class="hidden-mobile">{{ item.observacao || '-' }}</td>
                                    <td class="u-text-center acao">
                                        <el-button @click="abrirModalLicenca(item)" title="Alterar" type="info" icon="el-icon-edit" size="mini" plain></el-button>
                                        <el-button class="u-ml-10" @click="excluir('licenca', item.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                                    </td>
                                </tr>
                                <tr v-if="!licencas.length"><td colspan="6" class="u-text-center">Nenhuma licença lançada.</td></tr>
                            </tbody>
                        </table>
                    </div>
                </el-tab-pane>

                <!-- ============================= FALTAS ============================= -->
                <el-tab-pane label="FALTAS" name="falta">
                    <el-alert v-if="gradeBloqueada" type="error" :closable="false" class="u-mb-15"
                        :title="gradeMotivo"></el-alert>
                    <div class="u-text-right u-mb-10">
                        <el-button type="primary" size="small" icon="el-icon-plus" @click="abrirModalFalta()">ADICIONAR</el-button>
                    </div>

                    <div class="container-table">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th style="width: 110px;">Ausência</th>
                                    <!-- Cada lançamento cobre um dia só, então basta a data. -->
                                    <th style="width: 110px;">Data</th>
                                    <th style="width: 90px;" class="u-text-center">Quantidade</th>
                                    <th>Tipo Falta</th>
                                    <th style="width: 80px;">CID</th>
                                    <th class="hidden-mobile">Observação</th>
                                    <th style="width: 110px;" class="u-text-center">Ação</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in faltas" :key="item.id">
                                    <td>{{ rotuloAusencia(item) }}</td>
                                    <td>{{ formataData(item.periodo_inicial) }}</td>
                                    <td class="u-text-center">{{ quantidadeFalta(item) }}</td>
                                    <td>
                                        {{ item.tipo_descricao }}
                                        <div v-if="item.medico_nome" class="sub-info">
                                            {{ item.medico_nome }}{{ item.medico_crm ? ' — CRM ' + item.medico_crm : '' }}
                                        </div>
                                    </td>
                                    <td>{{ item.cid || '-' }}</td>
                                    <td class="hidden-mobile">{{ item.observacao || '-' }}</td>
                                    <td class="u-text-center acao">
                                        <el-button @click="abrirModalFalta(item)" title="Alterar" type="info" icon="el-icon-edit" size="mini" plain></el-button>
                                        <el-button class="u-ml-10" @click="excluir('falta', item.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                                    </td>
                                </tr>
                                <tr v-if="!faltas.length"><td colspan="7" class="u-text-center">Nenhuma falta lançada.</td></tr>
                            </tbody>
                        </table>
                    </div>
                </el-tab-pane>

                <!-- ============================= FÉRIAS ============================= -->
                <el-tab-pane label="FÉRIAS" name="ferias">
                    <el-alert v-if="gradeBloqueada" type="error" :closable="false" class="u-mb-15"
                        :title="gradeMotivo"></el-alert>
                    <div class="u-text-right u-mb-10">
                        <el-button type="primary" size="small" icon="el-icon-plus" @click="abrirModalFerias()">ADICIONAR</el-button>
                    </div>

                    <div class="container-table">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th>Período Aquisitivo</th>
                                    <th style="width: 110px;">Data Início</th>
                                    <th style="width: 110px;">Retorno</th>
                                    <th style="width: 80px;" class="u-text-center">Nr. Dias</th>
                                    <th class="hidden-mobile">Observação</th>
                                    <th style="width: 110px;" class="u-text-center">Ação</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in ferias" :key="item.id">
                                    <td>{{ formataData(item.periodo_aquisitivo_inicio) }} à {{ formataData(item.periodo_aquisitivo_fim) }}</td>
                                    <td>{{ formataData(item.data_inicio) }}</td>
                                    <td>{{ formataData(item.data_retorno) }}</td>
                                    <td class="u-text-center">{{ item.nr_dias }}</td>
                                    <td class="hidden-mobile">{{ item.observacao || '-' }}</td>
                                    <td class="u-text-center acao">
                                        <el-button @click="abrirModalFerias(item)" title="Alterar" type="info" icon="el-icon-edit" size="mini" plain></el-button>
                                        <el-button class="u-ml-10" @click="excluir('ferias', item.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                                    </td>
                                </tr>
                                <tr v-if="!ferias.length"><td colspan="6" class="u-text-center">Nenhuma férias lançada.</td></tr>
                            </tbody>
                        </table>
                    </div>
                </el-tab-pane>

                <!-- ============================= FOLHA ============================== -->
                <el-tab-pane label="FOLHA" name="folha">
                    <el-alert v-if="gradeBloqueada" type="error" :closable="false" class="u-mb-15"
                        :title="gradeMotivo"></el-alert>
                    <el-row :gutter="10" class="u-mb-15">
                        <el-col :xs="12" :sm="5" :md="4">
                            <label class="grade-label">Competência</label>
                            <el-select v-model="competencia.mes" placeholder="Mês" @change="getGrade" style="width: 100%;">
                                <el-option v-for="m in meses" :key="m.value" :label="m.label" :value="m.value"></el-option>
                            </el-select>
                        </el-col>
                        <el-col :xs="12" :sm="4" :md="3">
                            <label class="grade-label">&nbsp;</label>
                            <el-input-number v-model="competencia.ano" :min="2000" :max="2100" :controls="false"
                                @change="getGrade" style="width: 100%;"></el-input-number>
                        </el-col>
                    </el-row>

                    <el-alert v-for="(aviso, i) in gradeAvisos" :key="i" type="warning" :closable="false" class="u-mb-10" :title="aviso"></el-alert>

                    <div v-if="!carregando && !gradeColunas.length" class="u-text-center u-mt-25 u-mb-25">
                        Nenhum evento configurado para a grade.
                        <router-link to="/admin/folha-ponto/configuracao">Configurar os eventos exibidos</router-link>.
                    </div>

                    <!-- Campos de lançamento, no mesmo formato do sistema de RH -->
                    <el-row :gutter="10">
                        <el-col :xs="12" :sm="6" :md="4" v-for="col in gradeColunas" :key="col.evento_cod">
                            <div class="grade-campo">
                                <label class="grade-label" :title="col.descricao">
                                    {{ col.descricao }}<span class="grade-codigo">({{ col.evento_cod }})</span>
                                    <el-tag v-if="col.fora_da_lista" size="mini" type="warning" class="u-ml-5">fora da lista</el-tag>
                                </label>
                                <el-input v-model="grade[col.evento_cod]" :placeholder="placeholderGrade(col)"
                                    :disabled="col.consolidado || col.somente_leitura || gradeBloqueada"
                                    @input="digitarNaGrade(col)" @blur="formatarCampo(col)" size="small"></el-input>
                                <!-- Vem da aba Faltas: digitar aqui somaria ao que a falta
                                     já produz e o arquivo sairia com o dobro. -->
                                <div v-if="col.consolidado" class="grade-origem">
                                    <i class="el-icon-bottom-left"></i> total da aba Faltas
                                </div>
                            </div>
                        </el-col>
                    </el-row>

                    <el-form label-position="top" class="u-mt-10">
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="12">
                                <el-form-item label="Justificativa Licenças e Férias">
                                    <el-input class="u-mt-10" type="textarea" :rows="3" :value="gradeJustificativa" readonly style="border-top: 1px solid rgb(152, 152, 152) !important; border-left: 1px solid rgb(152, 152, 152) !important; border-right: 1px solid rgb(152, 152, 152) !important;"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="12">
                                <el-form-item label="Observações">
                                    <el-input class="u-mt-10" type="textarea" :rows="3" v-model="gradeObservacao" maxlength="255" :disabled="gradeBloqueada" style="border-top: 1px solid rgb(152, 152, 152) !important; border-left: 1px solid rgb(152, 152, 152) !important; border-right: 1px solid rgb(152, 152, 152) !important;"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row :gutter="10">
                            <el-col :xs="24" class="u-text-right">
                                <el-button type="primary" icon="el-icon-check" @click="salvarGrade" :disabled="gradeBloqueada">SALVAR</el-button>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-tab-pane>
            </el-tabs>
        </div>

        <!-- ========================== MODAL LICENÇA ========================== -->
        <el-dialog title="Licença" :visible.sync="modal.licenca" width="70%" :close-on-click-modal="false">
            <el-form :model="formLicenca" ref="formLicenca" label-position="top" class="u-mt-20">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12"><el-form-item label="Servidor"><el-input :value="servidor.nome" disabled></el-input></el-form-item></el-col>
                    <el-col :xs="24" :sm="12"><el-form-item label="Instituição"><el-input :value="servidor.instituicao_nome" disabled></el-input></el-form-item></el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Data início" prop="data_inicio" :rules="[$requiredChange]">
                            <el-date-picker v-model="formLicenca.data_inicio" type="date" value-format="yyyy-MM-dd"
                                format="dd/MM/yyyy" placeholder="dd/mm/aaaa" style="width: 100%;" @change="calculaDiasLicenca"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Data final">
                            <el-date-picker v-model="formLicenca.data_final" type="date" value-format="yyyy-MM-dd"
                                format="dd/MM/yyyy" placeholder="dd/mm/aaaa" style="width: 100%;" @change="calculaDiasLicenca"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Nr. Dias">
                            <el-input-number v-model="formLicenca.nr_dias" :min="0" :controls="false" style="width: 100%;"></el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24">
                            <el-form-item label="Tipo" prop="tipo_cod" :rules="[$requiredChange]">
                                <el-select v-model="formLicenca.tipo_cod" filterable placeholder="Selecione o tipo de licença" style="width: 100%;">
                                    <el-option-group v-for="g in grupos(tiposAfastamento)" :key="g.label" :label="g.label">
                                        <el-option v-for="t in g.itens" :key="t.codigo" :label="t.descricao" :value="t.codigo"></el-option>
                                    </el-option-group>
                                </el-select>
                            </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item label="Observação">
                            <el-input v-model="formLicenca.observacao" maxlength="255"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer">
                <el-button @click="modal.licenca = false">CANCELAR</el-button>
                <el-button class="u-ml-10" type="primary" @click="salvarLicenca">SALVAR</el-button>
            </span>
        </el-dialog>

        <!-- =========================== MODAL FALTA =========================== -->
        <el-dialog title="Falta" :visible.sync="modal.falta" width="70%" :close-on-click-modal="false">
            <el-form :model="formFalta" ref="formFalta" label-position="top" class="u-mt-20">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12"><el-form-item label="Servidor"><el-input :value="servidor.nome" disabled></el-input></el-form-item></el-col>
                    <el-col :xs="24" :sm="12"><el-form-item label="Instituição"><el-input :value="servidor.instituicao_nome" disabled></el-input></el-form-item></el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Ausência">
                            <el-select v-model="formFalta.ausencia" style="width: 100%;" @change="changeAusenciaFalta">
                                <el-option label="Integral" :value="1"></el-option>
                                <el-option label="Meio Período" :value="2"></el-option>
                                <el-option label="Horas" :value="3"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" v-if="formFalta.ausencia === 2">
                        <el-form-item label="Período">
                            <el-select v-model="formFalta.meio_periodo" style="width: 100%;">
                                <el-option label="1º Período" :value="1"></el-option>
                                <el-option label="2º Período" :value="2"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24">
                            <el-form-item label="Tipo" prop="tipo_cod" :rules="[$requiredChange]">
                                <el-select v-model="formFalta.tipo_cod" filterable placeholder="Selecione o tipo de falta"
                                    style="width: 100%;" @change="changeTipoFalta">
                                    <el-option-group v-for="g in grupos(tiposFaltaDaAusencia)" :key="g.label" :label="g.label">
                                        <el-option v-for="t in g.itens" :key="t.codigo" :label="t.descricao" :value="t.codigo"></el-option>
                                    </el-option-group>
                                </el-select>
                            </el-form-item>
                    </el-col>
                </el-row>
                <!-- Ausência em horas é sempre de um dia só: some o período e a
                     quantidade passa a ser digitada em horas. -->
                <el-row :gutter="10" v-if="faltaEmHoras">
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Data" prop="periodo_inicial" :rules="[$requiredChange]">
                            <el-date-picker v-model="formFalta.periodo_inicial" type="date" value-format="yyyy-MM-dd"
                                format="dd/MM/yyyy" placeholder="dd/mm/aaaa" style="width: 100%;"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Qtd. de horas">
                            <el-input v-model="formFalta.horas" placeholder="000:00"
                                @input="digitarHorasFalta"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10" v-else>
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Período Inicial" prop="periodo_inicial" :rules="[$requiredChange]">
                            <el-date-picker v-model="formFalta.periodo_inicial" type="date" value-format="yyyy-MM-dd"
                                format="dd/MM/yyyy" placeholder="dd/mm/aaaa" style="width: 100%;" @change="calculaDiasFalta"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Período Final">
                            <el-date-picker v-model="formFalta.periodo_final" type="date" value-format="yyyy-MM-dd"
                                format="dd/MM/yyyy" placeholder="dd/mm/aaaa" style="width: 100%;" @change="calculaDiasFalta"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Nº de dias">
                            <el-input-number v-model="formFalta.nr_dias" :min="0" :controls="false" style="width: 100%;"></el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>
                <!-- Campos do atestado: aparecem conforme o tipo escolhido, marcado
                     em Folha de Ponto > Configurações > Tipos de Falta. -->
                <el-row :gutter="10" v-if="faltaPedeMedico || faltaPedeCid">
                    <el-col :xs="24" :sm="12" v-if="faltaPedeMedico">
                        <el-form-item label="Médico">
                            <el-input v-model="formFalta.medico_nome" maxlength="120"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="6" v-if="faltaPedeMedico">
                        <el-form-item label="CRM">
                            <el-input v-model="formFalta.medico_crm" maxlength="30"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="6" v-if="faltaPedeCid">
                        <el-form-item label="CID">
                            <el-input v-model="formFalta.cid" maxlength="10" placeholder="Ex.: M25.5"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item label="Observação">
                            <el-input v-model="formFalta.observacao" maxlength="255"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer">
                <el-button @click="modal.falta = false">CANCELAR</el-button>
                <el-button class="u-ml-10" type="primary" @click="salvarFalta">SALVAR</el-button>
            </span>
        </el-dialog>

        <!-- =========================== MODAL FÉRIAS ========================== -->
        <el-dialog title="Férias" :visible.sync="modal.ferias" width="70%" :close-on-click-modal="false">
            <el-form :model="formFerias" ref="formFerias" label-position="top" class="u-mt-20">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12"><el-form-item label="Servidor"><el-input :value="servidor.nome" disabled></el-input></el-form-item></el-col>
                    <el-col :xs="24" :sm="12"><el-form-item label="Instituição"><el-input :value="servidor.instituicao_nome" disabled></el-input></el-form-item></el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item label="Período de Aquisição" prop="periodo_aquisitivo_cod" :rules="[$requiredChange]">
                            <el-select v-model="formFerias.periodo_aquisitivo_cod" filterable placeholder="Selecione o período aquisitivo"
                                :loading="loadingPeriodos" style="width: 100%;" @change="changePeriodoAquisitivo">
                                <el-option v-for="p in periodosAquisitivos" :key="p.codigo" :label="p.descricao" :value="p.codigo"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Data Início" prop="data_inicio" :rules="[$requiredChange]">
                            <el-date-picker v-model="formFerias.data_inicio" type="date" value-format="yyyy-MM-dd"
                                format="dd/MM/yyyy" placeholder="dd/mm/aaaa" style="width: 100%;"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Nr. Dias">
                            <el-input-number v-model="formFerias.nr_dias" :min="1" :max="Number(configTelas.ferias_dias_max) || 30" :controls="false" style="width: 100%;"></el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item label="Observação">
                            <el-input v-model="formFerias.observacao" maxlength="255"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer">
                <el-button @click="modal.ferias = false">CANCELAR</el-button>
                <el-button class="u-ml-10" type="primary" @click="salvarFerias">SALVAR</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
export default {
    data: () => ({
        aba: 'folha',
        carregando: true,
        loadingPeriodos: false,
        servidor: {},
        licencas: [],
        faltas: [],
        ferias: [],
        tiposAfastamento: [],
        tiposFalta: [],
        periodosAquisitivos: [],
        gradeColunas: [],
        gradeAvisos: [],
        gradeObservacao: '',
        gradeJustificativa: '',
        gradeBloqueada: false,
        gradeMotivo: '',
        gradeDiasFerias: 0,
        gradeDiasLicenca: 0,
        grade: {},
        configTelas: { ferias_dias_padrao: 30, ferias_dias_max: 30 },
        competencia: { mes: new Date().getMonth() + 1, ano: new Date().getFullYear() },
        meses: [
            { value: 1, label: 'Janeiro' }, { value: 2, label: 'Fevereiro' }, { value: 3, label: 'Março' },
            { value: 4, label: 'Abril' }, { value: 5, label: 'Maio' }, { value: 6, label: 'Junho' },
            { value: 7, label: 'Julho' }, { value: 8, label: 'Agosto' }, { value: 9, label: 'Setembro' },
            { value: 10, label: 'Outubro' }, { value: 11, label: 'Novembro' }, { value: 12, label: 'Dezembro' }
        ],
        modal: { licenca: false, falta: false, ferias: false },
        formLicenca: {},
        formFalta: {},
        formFerias: {}
    }),
    computed: {
        /**
         * Campos de DIAS só aceitam fração quando o meio período é exportado como
         * metade da quantidade. No modo 'flag' a meia falta vai inteira com o
         * marcador da posição 047, e a casa decimal não teria uso.
         */
        fracaoEmDias () {
            return this.configTelas.meio_dia && this.configTelas.meio_dia !== 'flag'
        },
        competenciaLabel () {
            return `${String(this.competencia.mes).padStart(2, '0')}/${this.competencia.ano}`
        },
        /** Salário atual do cadastro do RH — referência, não o valor da competência. */
        salarioBase () {
            const v = this.servidor.salario_valor
            if (v === null || v === undefined || v === '') return '-'
            return Number(v).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
        faltaEmHoras () {
            return Number(this.formFalta.ausencia) === 3
        },
        /**
         * O tipo tem de combinar com a ausência: em horas só entram os tipos que o
         * RH digita em horas (FALTAS INJUS HORAS hoje); nas demais, só os de dia.
         */
        tiposFaltaDaAusencia () {
            return this.tiposFalta.filter(t =>
                this.faltaEmHoras ? t.tipo_lancamento === 'H' : t.tipo_lancamento !== 'H')
        },
        /** Tipo de falta atualmente escolhido no modal. */
        tipoFaltaSelecionado () {
            return this.tiposFalta.find(t => t.codigo === this.formFalta.tipo_cod) || null
        },
        faltaPedeMedico () {
            return !!(this.tipoFaltaSelecionado && this.tipoFaltaSelecionado.pede_medico)
        },
        faltaPedeCid () {
            return !!(this.tipoFaltaSelecionado && this.tipoFaltaSelecionado.pede_cid)
        }
    },
    mounted () {
        this.getConfigTelas()
        this.resetFormLicenca()
        this.resetFormFalta()
        this.resetFormFerias()
        this.getServidor()
    },
    methods: {
        baseUrl () {
            return `${this.$store.state.config.baseUrlApi}/api/folha-ponto`
        },
        registro () {
            return this.$route.params.registro
        },
        /** Dias, ou horas quando o tipo é digitado em horas. */
        rotuloAusencia (item) {
            const ausencia = Number(item.ausencia)
            if (ausencia === 3) return 'Horas'
            if (ausencia === 2) return 'Meio Período'
            return 'Integral'
        },
        quantidadeFalta (item) {
            if (Number(item.ausencia) === 3 || item.tipo_lancamento === 'H') {
                return `${item.qtd_horas}h${String(item.qtd_minutos).padStart(2, '0')}`
            }
            return Number(item.nr_dias).toLocaleString('pt-BR', { minimumFractionDigits: 2 })
        },
        formataData (data) {
            if (!data) return '-'
            const d = String(data).substring(0, 10).split('-')
            return d.length === 3 ? `${d[2]}/${d[1]}/${d[0]}` : data
        },
        voltar () {
            this.$router.push({
                path: '/admin/folha-ponto/servidor',
                query: { instituicao_cod: this.$route.query.instituicao_cod || this.servidor.instituicao_cod }
            })
        },

        /* ------------------------------ carga ------------------------------ */
        // Parâmetros definidos em Folha de Ponto > Configurações > Telas.
        getConfigTelas () {
            this.$axios.get(`${this.baseUrl()}/configuracao/telas`, this.$store.getters.getHeaderAuth)
                .then(res => { this.configTelas = res.data || this.configTelas })
                .catch(() => {})
        },
        /**
         * Erros de regra de negócio da folha de ponto (competência fechada, trava
         * de exclusão) chegam como 422 com `throw.msg` — precisam aparecer para o
         * usuário, senão a trava parece um botão que simplesmente não funciona.
         */
        erro (e) {
            const msg = e && e.response && e.response.data && e.response.data.throw
                ? e.response.data.throw.msg
                : null

            if (msg) {
                window.eventBus.$emit('alert', { msg, type: 'warning' })
            }

            this.$store.commit('throwException', e)
        },
        getServidor () {
            this.$axios.get(`${this.baseUrl()}/servidor/${this.registro()}`, this.$store.getters.getHeaderAuth)
                .then(res => {
                    this.servidor = res.data
                    this.getLicencas()
                    this.getFaltas()
                    this.getFerias()
                    this.getGrade()
                    this.getTiposAfastamento()
                    this.getTiposFalta()
                })
                .catch(e => { this.carregando = false; this.$store.commit('throwException', e) })
        },
        getLicencas () {
            this.$axios.get(`${this.baseUrl()}/licenca/${this.registro()}`, this.$store.getters.getHeaderAuth)
                .then(res => { this.licencas = res.data || [] })
                .catch(e => this.$store.commit('throwException', e))
        },
        getFaltas () {
            this.$axios.get(`${this.baseUrl()}/falta/${this.registro()}`, this.$store.getters.getHeaderAuth)
                .then(res => { this.faltas = res.data || [] })
                .catch(e => this.$store.commit('throwException', e))
        },
        getFerias () {
            this.$axios.get(`${this.baseUrl()}/ferias/${this.registro()}`, this.$store.getters.getHeaderAuth)
                .then(res => { this.ferias = res.data || [] })
                .catch(e => this.$store.commit('throwException', e))
        },
        // A aba Folha é uma grade: as colunas vêm da curadoria de eventos e os
        // valores dos lançamentos já feitos naquela competência.
        getGrade () {
            this.carregando = true

            const params = { mes: this.competencia.mes, ano: this.competencia.ano }
            this.$axios.get(`${this.baseUrl()}/grade/${this.registro()}`, Object.assign({ params }, this.$store.getters.getHeaderAuth))
                .then(res => {
                    this.gradeColunas = res.data.colunas || []
                    this.gradeAvisos = res.data.avisos || []
                    this.gradeObservacao = res.data.observacao || ''
                    this.gradeJustificativa = res.data.justificativa_licencas || ''
                    this.gradeBloqueada = !!res.data.competencia_bloqueada
                    this.gradeMotivo = res.data.competencia_motivo || ''
                    this.gradeDiasFerias = Number(res.data.dias_ferias) || 0
                    this.gradeDiasLicenca = Number(res.data.dias_licenca) || 0

                    const valores = res.data.valores || {}
                    const grade = {}

                    this.gradeColunas.forEach(col => {
                        const v = valores[col.evento_cod]
                        grade[col.evento_cod] = v ? this.formataValor(v.quantidade, v.fracao, col.tipo_lancamento) : ''
                    })

                    this.grade = grade
                    this.carregando = false
                })
                .catch(e => { this.carregando = false; this.$store.commit('throwException', e) })
        },
        /** 4 e 30 em horas => "004:30"; em valor => "4,30"; em dias => "4" */
        /** Quantos dígitos o campo comporta: 000:00 são 5, o resto 8. */
        digitosDaGrade (tipo) {
            return tipo === 'H' ? 5 : 8
        },
        /** Se as duas últimas casas do campo são fração. */
        temFracao (tipo) {
            if (tipo === 'D') return this.fracaoEmDias
            return true
        },
        /**
         * Máscara posicional, como no sistema de RH: os dígitos entram pela
         * direita e empurram os anteriores. Digitando 2, depois 3, depois 2 num
         * campo de horas: 000:02 -> 000:23 -> 002:30.
         *
         * Qualquer caractere que não seja dígito é descartado, então não há como
         * digitar texto num campo numérico.
         */
        aplicarMascaraGrade (tipo, valor) {
            const digitos = String(valor === null || valor === undefined ? '' : valor)
                .replace(/\D/g, '')
                .slice(-this.digitosDaGrade(tipo))

            if (!digitos) return ''

            if (tipo === 'H') {
                const d = digitos.padStart(5, '0')
                return `${d.slice(0, 3)}:${d.slice(3)}`
            }

            if (!this.temFracao(tipo)) return this.milhar(digitos)

            const d = digitos.padStart(3, '0')
            return `${this.milhar(d.slice(0, -2))},${d.slice(-2)}`
        },
        digitarNaGrade (col) {
            this.$set(this.grade, col.evento_cod,
                this.aplicarMascaraGrade(col.tipo_lancamento, this.grade[col.evento_cod]))
        },
        /** 4370 -> 4.370 */
        milhar (inteiro) {
            const limpo = String(inteiro).replace(/^0+(?=\d)/, '')
            return limpo.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
        },
        formataValor (quantidade, fracao, tipo) {
            if (!quantidade && !fracao) return ''
            if (tipo === 'H') return `${String(quantidade).padStart(3, '0')}:${String(fracao).padStart(2, '0')}`

            // Um valor fracionado já gravado continua sendo exibido por inteiro,
            // mesmo com a máscara em modo inteiro — a tela não esconde dado.
            if (!this.temFracao(tipo) && !fracao) return this.milhar(String(quantidade))

            return `${this.milhar(String(quantidade))},${String(fracao).padStart(2, '0')}`
        },
        /**
         * Lê o campo já mascarado. As duas últimas casas são sempre a fração —
         * minutos em horas, centavos ou décimos de dia nos demais.
         */
        interpretaValor (texto, tipo) {
            const digitos = String(texto === null || texto === undefined ? '' : texto).replace(/\D/g, '')

            if (!digitos) return { quantidade: 0, fracao: 0 }

            const recorte = digitos.slice(-this.digitosDaGrade(tipo))

            if (!this.temFracao(tipo)) {
                return { quantidade: parseInt(recorte, 10) || 0, fracao: 0 }
            }

            const d = recorte.padStart(3, '0')

            const fracao = parseInt(d.slice(-2), 10) || 0
            const quantidade = parseInt(d.slice(0, -2), 10) || 0

            // 000:75 digitado vira 001:15 ao sair do campo
            if (tipo === 'H') {
                return { quantidade: quantidade + Math.floor(fracao / 60), fracao: fracao % 60 }
            }

            return { quantidade, fracao }
        },
        placeholderGrade (col) {
            if (col.tipo_lancamento === 'H') return '000:00'
            return this.temFracao(col.tipo_lancamento) ? '0,00' : '0'
        },
        formatarCampo (col) {
            const v = this.interpretaValor(this.grade[col.evento_cod], col.tipo_lancamento)
            this.$set(this.grade, col.evento_cod, this.formataValor(v.quantidade, v.fracao, col.tipo_lancamento))
        },
        salvarGrade () {
            const itens = this.gradeColunas.filter(col => !col.somente_leitura && !col.consolidado).map(col => {
                const v = this.interpretaValor(this.grade[col.evento_cod], col.tipo_lancamento)
                return {
                    evento_cod: col.evento_cod,
                    tipo_lancamento: col.tipo_lancamento,
                    quantidade: v.quantidade,
                    fracao: v.fracao
                }
            })

            window.eventBus.$emit('loading', true)

            this.$axios.post(`${this.baseUrl()}/grade/salvar`, Object.assign({
                mes: this.competencia.mes,
                ano: this.competencia.ano,
                observacao: this.gradeObservacao,
                itens
            }, this.payloadBase()), this.$store.getters.getHeaderAuth)
                .then(() => {
                    window.eventBus.$emit('loading', false)
                    window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
                    this.getGrade()
                })
                .catch(e => { window.eventBus.$emit('loading', false); this.erro(e) })
        },
        getTiposAfastamento () {
            this.$axios.get(`${this.baseUrl()}/tipos-afastamento`, this.$store.getters.getHeaderAuth)
                .then(res => { this.tiposAfastamento = res.data || [] })
                .catch(e => this.$store.commit('throwException', e))
        },
        getTiposFalta () {
            this.$axios.get(`${this.baseUrl()}/tipos-falta`, this.$store.getters.getHeaderAuth)
                .then(res => { this.tiposFalta = res.data || [] })
                .catch(e => this.$store.commit('throwException', e))
        },
        getPeriodosAquisitivos () {
            if (!this.servidor.matricula) return
            this.loadingPeriodos = true
            this.$axios.get(`${this.baseUrl()}/periodos-aquisitivos/${this.servidor.matricula}/${this.servidor.contrato}`, this.$store.getters.getHeaderAuth)
                .then(res => { this.periodosAquisitivos = res.data || []; this.loadingPeriodos = false })
                .catch(e => { this.loadingPeriodos = false; this.$store.commit('throwException', e) })
        },

        /* ------------------------------ modais ----------------------------- */
        abrirModalLicenca (item) {
            this.resetFormLicenca()
            if (item) this.formLicenca = Object.assign({}, this.formLicenca, item, { nr_dias: Number(item.nr_dias) })
            this.modal.licenca = true
        },
        abrirModalFalta (item) {
            this.resetFormFalta()
            if (item) {
                this.formFalta = Object.assign({}, this.formFalta, item, {
                    ausencia: Number(item.ausencia),
                    meio_periodo: item.meio_periodo ? Number(item.meio_periodo) : 1,
                    nr_dias: Number(item.nr_dias),
                    horas: this.formataValor(Number(item.qtd_horas), Number(item.qtd_minutos), 'H')
                })
            }
            this.modal.falta = true
        },
        abrirModalFerias (item) {
            this.resetFormFerias()
            this.getPeriodosAquisitivos()
            if (item) this.formFerias = Object.assign({}, this.formFerias, item, { nr_dias: Number(item.nr_dias) })
            this.modal.ferias = true
        },

        /* ------------------------------ formulários ------------------------ */
        resetFormLicenca () {
            this.formLicenca = { id: '', data_inicio: '', data_final: '', nr_dias: 0, tipo_cod: '', observacao: '' }
        },
        resetFormFalta () {
            this.formFalta = {
                id: '', ausencia: 1, meio_periodo: 1, tipo_cod: '', periodo_inicial: '', periodo_final: '',
                nr_dias: 0, tipo_lancamento: 'D', qtd_horas: 0, qtd_minutos: 0, horas: '',
                medico_nome: '', medico_crm: '', cid: '', observacao: ''
            }
        },
        resetFormFerias () {
            this.formFerias = {
                id: '', periodo_aquisitivo_cod: '', periodo_aquisitivo_inicio: '', periodo_aquisitivo_fim: '',
                data_inicio: '', nr_dias: Number(this.configTelas.ferias_dias_padrao) || 30, observacao: ''
            }
        },
        diasEntre (inicio, fim) {
            if (!inicio) return 0
            if (!fim) return 1
            const d1 = new Date(inicio + 'T00:00:00')
            const d2 = new Date(fim + 'T00:00:00')
            if (d2 < d1) return 0
            return Math.floor((d2 - d1) / 86400000) + 1
        },
        calculaDiasLicenca () {
            this.formLicenca.nr_dias = this.diasEntre(this.formLicenca.data_inicio, this.formLicenca.data_final)
        },
        calculaDiasFalta () {
            this.formFalta.nr_dias = this.diasEntre(this.formFalta.periodo_inicial, this.formFalta.periodo_final)
        },
        /**
         * Separa a lista em "veio do RH" e "cadastrado pelo município". Os
         * catálogos do SIP não cobrem tudo que a Educação lança (RECESSO ESCOLAR
         * é o caso mais comum), então a origem precisa ficar visível na hora de
         * escolher.
         */
        grupos (lista) {
            const sip = (lista || []).filter(t => !t.local)
            const local = (lista || []).filter(t => t.local)

            return [
                { label: 'Sistema de RH', itens: sip },
                { label: 'Cadastrados no município', itens: local }
            ].filter(g => g.itens.length)
        },
        /** Trocar a ausência muda a lista de tipos, então a escolha anterior sai. */
        changeAusenciaFalta () {
            this.formFalta.tipo_cod = ''
            this.formFalta.tipo_descricao = ''
            this.formFalta.tipo_lancamento = this.faltaEmHoras ? 'H' : 'D'

            if (this.faltaEmHoras) {
                this.formFalta.periodo_final = ''
                this.formFalta.nr_dias = 0

                // Um único tipo disponível já entra escolhido.
                const unico = this.tiposFaltaDaAusencia
                if (unico.length === 1) this.formFalta.tipo_cod = unico[0].codigo
            } else {
                this.formFalta.horas = ''
                this.formFalta.qtd_horas = 0
                this.formFalta.qtd_minutos = 0
                this.calculaDiasFalta()
            }
        },
        /** Mesma máscara posicional da grade: 000:00. */
        digitarHorasFalta () {
            const texto = this.aplicarMascaraGrade('H', this.formFalta.horas)
            const v = this.interpretaValor(texto, 'H')

            this.formFalta.horas = texto
            this.formFalta.qtd_horas = v.quantidade
            this.formFalta.qtd_minutos = v.fracao
        },
        changeTipoFalta (codigo) {
            // A forma de digitação (dias/horas/valor) e os campos de atestado são
            // definidos em Folha de Ponto > Configurações > Tipos de Falta.
            const tipo = this.tiposFalta.find(t => t.codigo === codigo)
            this.formFalta.tipo_lancamento = this.faltaEmHoras
                ? 'H'
                : ((tipo && tipo.tipo_lancamento) ? tipo.tipo_lancamento : 'D')

            // Trocar para um tipo que não pede atestado não pode deixar médico/CID
            // pendurados no registro.
            if (!tipo || !tipo.pede_medico) {
                this.formFalta.medico_nome = ''
                this.formFalta.medico_crm = ''
            }

            if (!tipo || !tipo.pede_cid) {
                this.formFalta.cid = ''
            }
        },
        changePeriodoAquisitivo (codigo) {
            const periodo = this.periodosAquisitivos.find(p => p.codigo === codigo)
            if (!periodo) return
            this.formFerias.periodo_aquisitivo_inicio = periodo.data_inicio
            this.formFerias.periodo_aquisitivo_fim = periodo.data_fim
        },

        /* -------------------------------- salvar ---------------------------
         * Depois de gravar em qualquer aba a grade é relida: a aba Folha exibe o
         * consolidado das faltas e o cabeçalho conta os dias de férias e licença
         * da competência. Sem isso a tela só ficava correta após recarregar.
         */
        payloadBase () {
            return {
                servidor_cod: this.servidor.registro,
                instituicao_cod: this.servidor.instituicao_cod
            }
        },
        salvar (recurso, form, refForm, aoSalvar) {
            this.$refs[refForm].validate(valido => {
                if (!valido) return

                const dados = Object.assign({}, form, this.payloadBase())
                const url = form.id
                    ? `${this.baseUrl()}/${recurso}/update/${form.id}`
                    : `${this.baseUrl()}/${recurso}/store`

                window.eventBus.$emit('loading', true)

                this.$axios.post(url, dados, this.$store.getters.getHeaderAuth)
                    .then(() => {
                        window.eventBus.$emit('loading', false)
                        window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
                        aoSalvar()
                    })
                    .catch(e => { window.eventBus.$emit('loading', false); this.erro(e) })
            })
        },
        salvarLicenca () {
            this.salvar('licenca', this.formLicenca, 'formLicenca', () => {
                this.modal.licenca = false
                this.getLicencas()
                this.getGrade()
            })
        },
        salvarFalta () {
            this.salvar('falta', this.formFalta, 'formFalta', () => {
                this.modal.falta = false
                this.getFaltas()
                this.getGrade()
            })
        },
        salvarFerias () {
            this.salvar('ferias', this.formFerias, 'formFerias', () => {
                this.modal.ferias = false
                this.getFerias()
                this.getGrade()
            })
        },
        excluir (recurso, id) {
            this.$msgbox.confirm('Tem certeza que deseja excluir este lançamento?', 'Atenção', {
                confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning'
            }).then(() => {
                window.eventBus.$emit('loading', true)
                this.$axios.delete(`${this.baseUrl()}/${recurso}/delete/${id}`, this.$store.getters.getHeaderAuth)
                    .then(() => {
                        window.eventBus.$emit('loading', false)
                        window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
                        if (recurso === 'licenca') this.getLicencas()
                        if (recurso === 'falta') this.getFaltas()
                        if (recurso === 'ferias') this.getFerias()

                        // Toda origem alimenta a aba Folha: faltas viram o consolidado
                        // dos eventos, licenças e férias entram nos contadores do topo
                        // e na justificativa.
                        this.getGrade()
                    })
                    .catch(e => { window.eventBus.$emit('loading', false); this.erro(e) })
            }).catch(() => {})
        }
    }
}
</script>

<style scoped>
.grade-campo { margin-bottom: 12px; }
.grade-label {
    display: block;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.3;
    height: 32px;
    overflow: hidden;
    margin-bottom: 3px;
    color: #606266;
}
.grade-codigo { color: #909399; font-weight: 400; margin-left: 3px; }
.sub-info { color: #909399; font-size: 11px; line-height: 1.3; margin-top: 2px; }
.grade-origem { color: #909399; font-size: 11px; line-height: 1.3; margin-top: 3px; }
</style>
